<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col.my-header.font-weight-bold
        | Ваши сервисы

  .container.services
    .row
      .col-12.col-sm-3(v-for="c in components")
        .widget
          component(:is="c.default")
</template>
<script>
var apiDriver = require("../apiDriver").default;
let components = require.context("@/components/Actid/Widgets/", true, /\.vue$/);
let widgets = components.keys().map(components);

export default {
  data() {
    return {
      subscriptions: [],
      components: [],
    };
  },

  computed: {},

  mounted() {
    let _subs = JSON.parse(
      JSON.stringify(this.$store.state.userData.subscriptions)
    );
    let is_admin = this.$store.state.userData.user.type === 1;
    let subs = [{ service_id: "system" }, ..._subs];
    if (is_admin) subs.push({ service_id: "admin" });
    let all = [];
    for (let sub of subs) {
      this.subscriptions.push(sub);
      let widget_search =
        typeof sub.service_id == "number"
          ? `service_${sub.service_id}_`
          : `${sub.service_id}_`;
      let sub_widgets = widgets.filter((w) => {
        if (!w.default.name) {
          console.warn("Widget name not defined", w.default);
          return false;
        }
        return w.default.name.indexOf(widget_search) == 0;
      });
      if (sub_widgets.length > 0) {
        // console.log("sub_widgets:", sub_widgets);
        all.push(...sub_widgets);
      }
    }
    this.components = all;
  },

  methods: {},
};
</script>

<style scoped lang="stylus">
.my-header {
  font-size: 26pt;
}

.services {
  margin-top: 20px;

  .service {
    margin-top: 20px;

    .subscribed_label {
      display: none;
    }

    .white_block {
      background-size: 150px !important;
      background-position: top right !important;
      background-repeat: no-repeat !important;
      position: relative;
    }

    .name {
      margin-bottom: 6px;
      font-size: 15pt;
      margin: 60px 0;
    }

    .description {
      font-size: 10pt;
      margin-bottom: 10px;
      color: #3e3e3e;
    }

    .price {
      margin-left: 110px;
      margin-bottom: 10px;
      font-size: 10pt;
      text-align: right;
      border-top: 1px solid #eee;
      padding-top: 5px;
    }

    .buttons {
      text-align: right;
      padding: 10px;
      padding-right: 0;

      .ask {
        text-decoration: underline;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        margin-right: 10px;
        opacity: 0.7;

        &:hover {
          opacity: 1;
        }
      }
    }

    &.subscribed {
      .subscribed_label {
        color: #4CAF50;
        border: 1px solid;
        display: inline-block;
        padding: 3px 10px;
        border-radius: 6px;
        font-size: 9pt;
        cursor: default;
        position: absolute;
        top: 15px;
        left: 15px;
      }
    }
  }
}
</style>

<style lang="scss">
.widget {
  background: #fff;
  border-radius: 15px;
  padding: 10px 15px;
  color: #484848;
  height: 120px;
  cursor: default;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  margin-bottom: 20px;
  overflow: hidden;

  .spinner-border {
    position: absolute;
    right: 10px;
  }

  .status {
    position: absolute;
    right: 10px;
    height: 8px;
    width: 8px;
    border-radius: 8px;
    z-index: 2;

    &.green {
      background-color: #4caf50;
    }

    &.red {
      background-color: #f44336;
      animation: red_status_animation 1s infinite;
    }

    &.orange {
      background-color: #ff9800;
      animation: orange_status_animation 1s infinite;
    }
  }

  .type_number {
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
      position: absolute;
      bottom: 0px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 90%;
    }

    .value {
      font-size: 60pt;
      position: relative;
      top: -25px;
      font-weight: bold;
    }
  }

  .type_link {
    .title {
      font-size: 26px;
      line-height: 25px;
      font-weight: bold;
      position: absolute;
      top: 15px;
      width: 90%;
      left: 15px;
      height: auto;
    }

    .arrow_link {
      position: absolute;
      right: 15px;
      bottom: 0;
      font-size: 42px;
      transition: 0.3s ease-in-out right;
    }

    &:hover {
      .arrow_link {
        right: 10px;
      }
    }

    a {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      margin: 0;
      color: #484848;
    }
  }

  .type_select_action {
    .title {
      font-size: 14px;
      font-weight: bold;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 90%;
    }
  }

  .type_big_number {
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
      position: absolute;
      bottom: 0px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 90%;
    }

    .value {
      font-size: 40pt;
      position: relative;
      top: -15px;
      font-weight: bold;
    }
  }

  .type_two_number {
    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
      position: absolute;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 90%;
    }

    .title.first {
      bottom: 0px;
    }

    .title.second {
      bottom: 0px;
      left: 50%;
    }

    .value {
      font-size: 25px;
      position: absolute;
      font-weight: bold;
    }

    .value.first {
      bottom: 35px;
    }

    .value.second {
      bottom: 35px;
      left: 50%;
    }
  }

  .type_list {
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
      position: absolute;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 90%;
      bottom: 0;
    }

    .value {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        .hide_on_hover {
          display: none;
        }
      }
    }
  }

  .loading_spinner {
    display: none;
  }

  .loading {
    .title {
      opacity: 0.5;
    }

    .value {
      display: none;
    }

    .loading_spinner {
      display: block;
    }

    .status {
      display: none;
    }

    .select_and_action {
      display: none;
    }
  }
}

@keyframes orange_status_animation {
  0% {
    box-shadow: 0 0 0 #ff9800;
    transform: scale(1);
  }

  50% {
    box-shadow: 0 0 20px #ff9800;
    transform: scale(1.2);
  }

  100% {
    box-shadow: 0 0 0 #ff9800;
    transform: scale(1);
  }
}

@keyframes red_status_animation {
  0% {
    box-shadow: 0 0 0 #f44336;
    transform: scale(1);
  }

  50% {
    box-shadow: 0 0 20px #f44336;
    transform: scale(1.2);
  }

  100% {
    box-shadow: 0 0 0 #f44336;
    transform: scale(1);
  }
}

@media (prefers-color-scheme: dark) {
  .widget {
    background: #161616;
    color: #e1e1e1;
  }

  .widget .type_link a {
    color: #e1e1e1;
  }
}
</style>